import { render, staticRenderFns } from "./ShortAnswer.vue?vue&type=template&id=ffd0dcbc&scoped=true"
import script from "./ShortAnswer.vue?vue&type=script&lang=js"
export * from "./ShortAnswer.vue?vue&type=script&lang=js"
import style0 from "./ShortAnswer.vue?vue&type=style&index=0&id=ffd0dcbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd0dcbc",
  null
  
)

export default component.exports